import { useEffect } from "react";
import { api } from "../lib/api";

const DEFAULT_TITLE = "Secret Angels · Directorio Exclusivo";

/**
 * Loads site-wide SEO from /api/settings and applies it to the document head.
 * Runs once at app boot regardless of which route is rendered first.
 */
export default function useSiteSeo() {
  useEffect(() => {
    if (!document.title || document.title.toLowerCase().includes("emergent")) {
      document.title = DEFAULT_TITLE;
    }
    let cancelled = false;
    api.get("/settings").then((r) => {
      if (cancelled) return;
      const s = r.data || {};
      if (s.title) document.title = s.title;
      const setMeta = (name, content) => {
        if (!content) return;
        let el = document.querySelector(`meta[name="${name}"]`);
        if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
        el.setAttribute("content", content);
      };
      const setProp = (prop, content) => {
        if (!content) return;
        let el = document.querySelector(`meta[property="${prop}"]`);
        if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
        el.setAttribute("content", content);
      };
      setMeta("description", s.description);
      setMeta("keywords", s.keywords);
      setProp("og:title", s.title);
      setProp("og:description", s.description);
      setProp("og:site_name", s.site_name);
      setProp("og:image", s.og_image);
    }).catch(() => {
      // settings endpoint unreachable → keep default title
    });
    return () => { cancelled = true; };
  }, []);
}
